// removed by extract-text-webpack-plugin
module.exports = {"name-flex":"name-flex___2iDRv center___2iqBf","name-label-logo":"name-label-logo___3gwIj center___2iqBf","name-logo":"name-logo___35xma","name":"name___3am7O h1___3_4RF","name-label":"name-label___2wcMD h5___l1yk7","other-plan-names-label":"other-plan-names-label___1Ecsz h5___l1yk7","plan-details-lede-img-wrap":"plan-details-lede-img-wrap___PgGT7 center___2iqBf","plan-details-lede-img":"plan-details-lede-img___q6g_h","secondary-plan-logo-wrap":"secondary-plan-logo-wrap___3Jnp5 center___2iqBf","secondary-plan-logo":"secondary-plan-logo___1hkcX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PlanScorecardNameHeader/PlanScorecardNameHeader.css
// module id = 906
// module chunks = 0